import React, { useEffect, useState } from 'react';
import { ReactSession } from "react-client-session";
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import Modal from 'react-bootstrap/Modal';
import DateConverter from '../Tools/DateConverter';
import VerificarPermisos from '../Tools/VerificarPermisos';
const server = process.env.REACT_APP_SERVER;

function PrincipalItinerario() {
    const [itinerario, setItinerario] = useState([]);
    const [fecha, setFecha] = useState(DateConverter.toIsoString(new Date()).substring(0, 10));
    const [empleados, setEmpleados] = useState([]);
    const [empleadoActual, setEmpleadoActual] = useState({});
    const [loading, setLoading] = useState(false);
    const [selectItinerario, setSelectItinerario] = useState({});
    const [detalleItinerario, setDetalleItinerario] = useState(false);
    const [informeEdit, setInformeEdit] = useState('');
    const [sucursales, setSucursales] = useState([]);
    const [asignarItinerario, setAsignarItinerario] = useState(false);
    const [sucursalAsignar, setSucursalAsignar] = useState(-1);
    const [itinerarioEditar, setItinerarioEditar] = useState(0);
    const [sucursalActual, setSucursalActual] = useState(-1);
    //const [edicionItinerario, setEdicionItinerario] = useState('N');
    const refrescarItinerario = () => {
        setLoading(true);
        fetch(`${server}/itinerario/lista`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                fecha, idemp: empleadoActual.ID_EMPLEADO, regional: ReactSession.get('regional')
            })
        })
            .then(res => res.json())
            .then(data => {
                //console.log(data);
                if (data.ok) {
                    setItinerario(data.ok);
                    //console.log(new Date().toISOString());
                    //console.log(DateConverter.toIsoString(new Date()));
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err))
            .finally(() => { setLoading(false); });
    };
    const obtenerEmpleados = () => {
        setLoading(true);
        fetch(`${server}/itinerario/empleados`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                idemp: ReactSession.get('idSession'), regional: ReactSession.get('regional')
            })
        })
            .then(res => res.json())
            .then(data => {
                //console.log(data);
                if (data.ok) {
                    setEmpleados(data.ok);
                    // Veamos, si el empleado esta en la lista usamos el actual, si no usamos el primero o el usuario actual
                    var emp = data.ok.find(o => o.ID_EMPLEADO === ReactSession.get('idSession'));
                    if (emp !== undefined) {
                        setEmpleadoActual(emp);
                    } else if (data.ok.length > 0) {
                        setEmpleadoActual(data.ok[0]);
                    } else {
                        setEmpleadoActual({
                            ID_EMPLEADO: ReactSession.get('idSession'),
                            GRUPO_ITINERARIO: 0
                        });
                    }
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err))
            .finally(() => { setLoading(false); });
    };
    useEffect(() => {
        obtenerEmpleados();
    }, []);
    useEffect(() => {
        refrescarItinerario();
    }, [empleadoActual, fecha]);
    const puedeVerTodosItinerario = () => {
        return VerificarPermisos.validarPermiso('22');
    };
    const elegirEmpleado = (e) => {
        setEmpleadoActual(empleados.find(o => o.ID_EMPLEADO === parseInt(e.target.value)));
    };
    const elegirFecha = (e) => {
        setFecha(e.target.value);
    };
    const verEditarInforme = (item) => {
        
            if (item.VISITA === 'N' || item.VISITA === 'P' || item.VISITA === 'S') {
                setSelectItinerario(item);
                setInformeEdit(UtilsBufer.getText(item.INFORME));
                setDetalleItinerario(true);
            }
        
    };
    const expandirTurno = (item) => {
        if (item.TURNO === 'M') {
            return 'Mañana';
        } else if (item.TURNO === 'N') {
            return 'Noche';
        } else if (item.TURNO === null) {
            return 'No aplica';
        } else {
            return 'Otro';
        }
    };
    const expandirVisita = (item) => {
        switch (item.VISITA) {
            case 'S': return '\u{2705}';    // Verde
            case 'P': return '\u{1F7E1}';   // Amarillo
            case 'N': return '\u{1F534}';   // Rojo
            default: return item.VISITA;
        }
    }
    const expandirInforme = (item) => {
        if (item.VISITA === 'S') {
            return '\u{1F4DD}'; // Papel
        } else if ((item.VISITA === 'P' || item.VISITA === 'N') && (fecha === DateConverter.toIsoString(new Date()).substring(0, 10))) {
            return '\u{270F}';  // Lapiz
        } else {
            return '';
        }
    };
    const expandirEditar = (item) => {
        //console.log(item.VISITA);
        if (item.VISITA === 'N' || (item.VISITA === 'P' && item.TIPO_SUCURSAL === 'EX')) {
            return '\u{2699}';
        } else {
            return '';   // Pruebas
        }
    };
    const puedeAlmacenarInforme = () => {
        // Solo el Colaborador del Itinerario, y si es del grupo 1, 2 o 4 solo el mismo dia y si la Visita esta en P o N, o si es S solo si es Lugar Externo     
        return empleadoActual.ID_EMPLEADO === ReactSession.get('idSession')
            && (empleadoActual.GRUPO_ITINERARIO === 3 || ((selectItinerario.VISITA === 'N' || selectItinerario.VISITA === 'P' || (selectItinerario.VISITA === 'S' && selectItinerario.TIPO_SUCURSAL === 'EX')) && fecha === DateConverter.toIsoString(new Date()).substring(0, 10)));
    };
    const almacenarInforme = () => {
        setLoading(true);
        fetch(`${server}/itinerario/informe`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                fecha, idItinerario: selectItinerario.ID_ITINERARIO, idemp: empleadoActual.ID_EMPLEADO, informe: informeEdit, regional: ReactSession.get('regional')
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    MsgUtils.msgCorrecto(data.ok);
                    setDetalleItinerario(false);
                    refrescarItinerario();
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err))
            .finally(() => { setLoading(false); });
    };
    const puedeAsignarItinerario = () => {
        var f = new Date();

        if (fecha !== DateConverter.toIsoString(f).substring(0, 10)) {
            return false; // No se puede de otros dias ni pasados ni futuros
        }

        if (empleadoActual.GRUPO_ITINERARIO === 1) {
            // Auto
            if (f.getDay() === 1) {
                return false;   // No hay automatico los lunes
            } else {
                var horaActual = f.getHours();
                var turnoActual = horaActual < 16 ? 'M' : 'N';

                var ultTurno = 'X';
                if (itinerario.length > 0) {
                    ultTurno = itinerario[itinerario.length - 1].TURNO;
                }

                if (ultTurno !== turnoActual && ((turnoActual === 'M' && horaActual >= 7) || (turnoActual === 'N' && horaActual >= 16))) {
                    return true;
                } else {
                    if (itinerario.length > 0 && itinerario[itinerario.length - 1].VISITA === 'S') {
                        return true;    // Si el ultimo ya fue visitado tambien dejamos asignar
                    } else {
                        return true; //se hizo cambio
                    }
                }
            }
        } else if (empleadoActual.GRUPO_ITINERARIO === 2) {
            // Manual
            if (itinerario.length < 1) {
                return true;    // Si no tiene itinerarios
            } else {
                if (itinerario[itinerario.length - 1].VISITA === 'S') {
                    return true;    // Si el ultimo ya fue visitado o es un lugar externo con Informe
                } else {
                    return true; //se hizo cambio
                }
            }
        } else if (empleadoActual.GRUPO_ITINERARIO === 3) {
            return true;    // Siempre puede en la fecha actual
        } else if (empleadoActual.GRUPO_ITINERARIO === 4) {
            return VerificarPermisos.validarPermiso('33');    // Solo si tiene el permiso especial
        } else {
            return true; //se hizo cambio
        }
    };
    const evaluarMostrarAsignarItinerario = () => {
        var infoEmple = JSON.parse(localStorage.getItem('info'));
        //console.log(infoEmple);
        //        if(infoEmple.EMPRESA_CARGO == 6){
        if (empleadoActual.GRUPO_ITINERARIO === 1) {
            // Si el empleado esta en el grupo 1 le asignamos uno aleatorio
            var turnoActual = new Date().getHours() < 16 ? 'Mañana' : 'Noche';
            if (window.confirm('¿Asignar Itinerario para el turno ' + turnoActual + '?')) {
                setLoading(true);
                fetch(`${server}/itinerario/auto`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        idemp: empleadoActual.ID_EMPLEADO, fecha, regional: ReactSession.get('regional'),'cargo':infoEmple.EMPRESA_CARGO
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.ok) {
                            MsgUtils.msgCorrecto(data.ok);
                            refrescarItinerario();
                        } else {
                            MsgUtils.msgError(data.error);
                        }
                    })
                    .catch(err => console.log(err))
                    .finally(() => { setLoading(false); });
            }
        } else if ([2, 3, 4].includes(empleadoActual.GRUPO_ITINERARIO)) {
            // Si tiene el permiso le dejamos escoger de otros
            // Si no tiene el permiso solo dejamos escoger si esta en el grupo 2 y si el seleccionado es el mismo que inicio sesion
            if (VerificarPermisos.validarPermiso('33') || (empleadoActual.GRUPO_ITINERARIO === 2 && empleadoActual.ID_EMPLEADO === infoEmple.ID_EMPLEADO)) { 
                mostrarAsignarItinerario();
            }
        } else {
            MsgUtils.msgError('No pertenece a ningún grupo de control de Itinerario o no tiene el permiso necesario');
        }
    };
    const mostrarAsignarItinerario = () => {
        setItinerarioEditar(0); // Nuevo
        setSucursalActual(-1);
        setAsignarItinerario(true);
        setLoading(true);
        // Cargar las Sucursales
        fetch(`${server}/sqlComun/sucursalofi`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: ReactSession.get('regional')
            })
        })
            .then(res => res.json())
            .then(data => {
                setSucursales(data.ok);
                setSucursalAsignar(data.ok[0].ID_SUCURSAL);  // Usar la primera de la lista
            })
            .catch(err => console.log(err))
            .finally(() => { setLoading(false); });
    };
    const elegirSucursal = (e) => {
        setSucursalAsignar(parseInt(e.target.value));
    };
    const almacenarItinerario = () => {
        var infoEmple = JSON.parse(localStorage.getItem('info'))
        console.log('Asignar: ' + sucursalAsignar + ', Actual: ' + sucursalActual);
        if (sucursalAsignar === sucursalActual) {
            MsgUtils.msgError('La Sucursal debe ser diferente a la actual');
            return;
        }

        setLoading(true);
        fetch(`${server}/itinerario/asignar`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                iditinerario: itinerarioEditar, fecha, idemp: empleadoActual.ID_EMPLEADO, 
                idsuc: sucursalAsignar, regional: ReactSession.get('regional'),
                'cargo':infoEmple.EMPRESA_CARGO
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    MsgUtils.msgCorrecto(data.ok);
                    setAsignarItinerario(false);
                    refrescarItinerario();
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err))
            .finally(() => { setLoading(false); });
    };
    const puedeEditarItinerario = () => {
        return empleadoActual.GRUPO_ITINERARIO === 2 || empleadoActual.GRUPO_ITINERARIO === 3 || (empleadoActual.GRUPO_ITINERARIO === 4 && VerificarPermisos.validarPermiso('33'));
    };
    const mostrarEditarItinerario = (item) => {
        if (item.TIPO_SUCURSAL !== 'EX' && item.VISITA !== 'N') {
            MsgUtils.msgError('No se puede cambiar este itinerario');
            return;
        }

        setItinerarioEditar(item.ID_ITINERARIO);    // Edicion
        setSucursalActual(item.ID_SUCURSAL);    // Actual
        setAsignarItinerario(true);
        setLoading(true);
        // Cargar las Sucursales
        fetch(`${server}/sqlComun/sucursalofi`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: ReactSession.get('regional')
            })
        })
            .then(res => res.json())
            .then(data => {
                setSucursales(data.ok);
                setSucursalAsignar(data.ok[0].ID_SUCURSAL);  // Usar la primera de la lista
            })
            .catch(err => console.log(err))
            .finally(() => { setLoading(false); });
    };
    const sincronizarAsistencia = () => {
        setLoading(true);
        fetch(`${server}/itinerario/syncasistencia`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                idemp: empleadoActual.ID_EMPLEADO, fecha, idsuc: selectItinerario.ID_SUCURSAL, dblink: selectItinerario.DB_LINK, regional: ReactSession.get('regional')
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    MsgUtils.msgCorrecto(data.ok);
                    refrescarItinerario();
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err))
            .finally(() => { setLoading(false); });
    };
    return (
        <div>
            <div>
                <div className='container-fluid bg-dark bg-gradient py-1'>
                    <div className='btn-group'>
                        <div className='row row-cols-1 row-cols-md-2 g-1'>
                            {puedeVerTodosItinerario() && <div className='col'>
                                <div className="input-group input-group-sm my-auto" >
                                    <span className="input-group-text bg-secondary bg-gradient text-light" >Colaborador</span>
                                    <select className=" form-select text-center "
                                        value={empleadoActual.ID_EMPLEADO} onChange={elegirEmpleado}
                                    >
                                        {empleados.map((item) => {
                                            return (<option key={item.ID_EMPLEADO} value={item.ID_EMPLEADO}>{item.NOMBREX}</option>);
                                        })}
                                    </select>
                                </div>
                            </div>}
                            <div className='col'>
                                <div className="input-group input-group-sm my-auto">
                                    <span className="input-group-text bg-secondary bg-gradient text-light my-auto">Fecha</span>
                                    <input type="date" className="form-control modificado" disabled={loading} value={fecha} onChange={(e) => elegirFecha(e)}
                                        aria-describedby="basic-addon1" id="fechaItinerario" />
                                </div>
                            </div>
                            {/* <div className='col'>
                                <span>Grupo: {empleadoActual.GRUPO_ITINERARIO}</span>                                
                            </div> */}
                        </div>
                        <div className={`btn btn-sm btn-secondary`}
                            onClick={refrescarItinerario}
                        >
                            Refrescar
                        </div>
                    </div>
                    <div className='btn-group align-right'>
                        {puedeAsignarItinerario() &&
                            <div className={`btn btn-sm btn-primary`}
                                onClick={evaluarMostrarAsignarItinerario}
                            >
                                Asignar
                            </div>}
                    </div>
                </div>
                <div className='table-responsive'>
                    <table className="table table-striped table-bordered table-sm table-hover">
                        <thead className='bg-secondary bg-gradient text-center fw-bold text-light'>
                            <tr>
                                <th scope="col">TURNO</th>
                                <th scope="col">SUCURSAL</th>
                                <th scope="col">VISITA</th>
                                <th scope="col">INFORME</th>
                                {puedeEditarItinerario() && <th scope="col">CAMBIAR</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {itinerario.map((item) => {
                                return (
                                    <tr key={item.ID_ITINERARIO} className="my-auto">
                                        <th className="col-1">{expandirTurno(item)}</th>
                                        <td className='col-4'>{item.SUCURSAL}</td>
                                        <td className="col-1">{expandirVisita(item)}</td>
                                        <td className="col-1">
                                            <a className='btn btn-transparent fs-4 m-0 p-0' id={item.ID_ITINERARIO}
                                                onClick={(e) => verEditarInforme(item)}>{expandirInforme(item)}
                                            </a>
                                        </td>
                                        {puedeEditarItinerario() && <td className="col-1">
                                            <a className='btn btn-transparent fs-4 m-0 p-0' id={item.ID_ITINERARIO}
                                                onClick={(e) => mostrarEditarItinerario(item)}>{expandirEditar(item)}
                                            </a>
                                        </td>}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            <Modal show={detalleItinerario} onHide={() => setDetalleItinerario(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>{selectItinerario.SUCURSAL}</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {puedeAlmacenarInforme() ?
                        <textarea type='text' className='form-control' style={{ height: "200px" }} value={informeEdit} onChange={(e) => setInformeEdit(e.target.value)}></textarea> :
                        <textarea type='text' className='form-control' style={{ height: "200px" }} value={informeEdit} readOnly={true}></textarea>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button className={`btn btn-sm btn-secondary`} onClick={sincronizarAsistencia}>Sync</button>
                    {puedeAlmacenarInforme() &&
                        <button className={`btn btn-sm btn-primary`} onClick={almacenarInforme}>Guardar</button>}
                </Modal.Footer>
            </Modal>
            <Modal show={asignarItinerario} onHide={() => setAsignarItinerario(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>{itinerarioEditar > 0 ? 'Modificar' : 'Asignar'} Itinerario</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className="input-group-text bg-secondary bg-gradient text-light" >Sucursal</span>
                    <select className=" form-select text-center" onChange={elegirSucursal}
                    >
                        {sucursales.map((item) => {
                            if (item.ID_SUCURSAL !== sucursalActual) {
                                return (<option key={item.ID_SUCURSAL} value={item.ID_SUCURSAL}>{item.SUCURSAL}</option>);
                            }
                        })}
                    </select>
                </Modal.Body>
                <Modal.Footer>
                    <button className={`btn btn-sm btn-primary`} onClick={almacenarItinerario}>Guardar</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default PrincipalItinerario;
